import React from "react";
import {default as ItemImageDysonSphere} from '../DSP/Components/ItemImage/ItemImage';
import {default as ItemImageSatisfactory} from '../Satisfactory/Components/ItemImage/ItemImage';
import {FactoryGameType} from "../types";

type Props = {
    item: string,
    gameType: FactoryGameType,
}

export default function ItemImage({ item, gameType }: Props) {
    switch (gameType) {
        case FactoryGameType.DysonSphere:
            return <ItemImageDysonSphere item={item} />
        case FactoryGameType.Satisfactory:
            return <ItemImageSatisfactory item={item} />
    }
}
